<template>
    <div v-if="sidebarRoutes">
        <div v-for="(sidebarRoute, key) in sidebarRoutes">
            <template v-if="!isNaN(key)">
                <sidebar-link
                    :href="route(sidebarRoute.route)"
                    :active="route().current(sidebarRoute.route)"
                    :parent="true"
                    :linkType="sidebarRoute.hasOwnProperty('linkType') ? sidebarRoute.linkType : linkType"
                    :target="sidebarRoute.hasOwnProperty('target') ? sidebarRoute.target : target"
                    v-if="!sidebarRoute.hasOwnProperty('url') && sidebarRoute.hasOwnProperty('route') && sidebarRoute.visible"
                >
                    {{ sidebarRoute.text }}
                </sidebar-link>
                <sidebar-link
                    :href="sidebarRoute.url"
                    :active="currentUrl.includes(sidebarRoute.url)"
                    :parent="true"
                    linkType="normal"
                    :target="sidebarRoute.hasOwnProperty('target') ? sidebarRoute.target : target"
                    v-else-if="sidebarRoute.hasOwnProperty('url') && sidebarRoute.visible"
                >
                    {{ sidebarRoute.text }}
                </sidebar-link>
<!--                Children-->
                <template v-if="sidebarRoutes[sidebarRoute.route]
                    && (sidebarRoute.route == currentSideRoute || sidebarRoute.route == currentSideRoute + '.index')">
                    <template v-for="childRoute in sidebarRoutes[sidebarRoute.route]">
                        <sidebar-link
                            :href="route(childRoute.route)"
                            :active="route().current(childRoute.route)"
                            :parent="false"
                            :linkType="childRoute.hasOwnProperty('linkType') ? childRoute.linkType : linkType"
                            :target="childRoute.hasOwnProperty('target') ? childRoute.target : target"
                            v-if="!childRoute.hasOwnProperty('url') && childRoute.hasOwnProperty('route') && childRoute.visible"
                        >
                            {{ childRoute.text }}
                        </sidebar-link>
                        <sidebar-link
                            :href="childRoute.url"
                            :active="currentUrl.includes(childRoute.url)"
                            :parent="false"
                            linkType="normal"
                            :target="childRoute.hasOwnProperty('target') ? childRoute.target : target"
                            v-else-if="childRoute.hasOwnProperty('url') && childRoute.visible"
                        >
                            {{ childRoute.text }}
                        </sidebar-link>

                        <template v-if="subRoutes[childRoute.route]">
                            <template v-for="subChildRoute in subRoutes[childRoute.route]">
                                <sidebar-link
                                    :href="route(subChildRoute.route)"
                                    :active="route().current(subChildRoute.route)"
                                    :parent="false"
                                    v-if="subChildRoute.visible"
                                >
                                    <div class="pl-5">{{ subChildRoute.text }}</div>
                                </sidebar-link>
                            </template>
                        </template>
                    </template>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
import SidebarLink from '@/Components/SidebarLink.vue'

import { computed } from 'vue'

export default {
    components: {
        SidebarLink
    },
    props: {
        subRoutes: {
            type: Object
        },
        linkType: {
            type: String,
            default: 'inertia',//regular, normal, anything but inertia
        },
        target: {
            type: String,
            default: '_blank'
        },
    },
    setup (props) {
        const sidebarRoutes = computed(() => {
            let routeParts = (route().current()) ? route().current().split('.') : []
            let sideRoutes = []
            let subRoutes = props.subRoutes

            if (props.subRoutes[routeParts[0]]) {
                sideRoutes = props.subRoutes[routeParts[0]]//Get the child routes of the mainParentRoute

                // Check if routes have children
                sideRoutes.forEach(function(sideRoute)
                {
                    if (subRoutes[sideRoute.route]) {
                        sideRoutes[sideRoute.route] = subRoutes[sideRoute.route]
                    }
                })
            }

            return sideRoutes
        })

        const currentSideRoute = computed(() => {
            let routeParts = (route().current()) ? route().current().split('.') : []
            let currentSideRoute = routeParts[0]

            if (routeParts.length > 1)
            {
                if (routeParts[2] && routeParts[2] == 'index')
                {
                    currentSideRoute += '.' + routeParts[1] + '.index'
                }
                else
                {
                    currentSideRoute += '.' + routeParts[1]
                }
            }

            return currentSideRoute;
        })

        return {
            sidebarRoutes,
            currentSideRoute
        }
    },
    created: function () {
        this.currentUrl = window.location.href;
    },
}

</script>
